import i18n from "../i18nt/index";

// export const BASE_PAGE = "/";
// export const LOGIN_PAGE = "/login";
// export const REGISTER_PAGE = "/register";
// export const FORGOT_PASSWORD_PAGE = "/forgot-password";
// export const HOME_PAGE = "/";
// export const ERROR_PAGE = "/error-page";
// export const NOT_FOUND_PAGE = "/not-found";
export const AUTH_CALLBACK_PAGE = "/api/auth/:provider/callback";

export const PAGES = {
  BASE: {
    route: "/",
    title: i18n.t("pages.home"),
  },
  HOME: {
    route: "/home/*",
    title: i18n.t("pages.home"),
  },
  REGISTER: {
    route: "/register/*",
    title: i18n.t("pages.register"),
    nestedRoutes: {
      FIRST_STEP: {
        route: "/register/first-step/*",
        title: i18n.t("pages.register.nestedRoutes.firstStep"),
      },
      SECOND_STEP: {
        route: "/register/second-step/*",
      },
    },
  },
  LOGIN: {
    route: "/login/*",
    title: i18n.t("pages.login"),
  },
  FORGOT_PASSWORD: {
    route: "/forgot-password/*",
    title: i18n.t("pages.forgotPassword"),
  },
  ERROR: {
    route: "/error-page",
    title: i18n.t("pages.error"),
  },
  NOT_FOUND: {
    route: "/not-found",
    title: i18n.t("pages.notFound"),
  },
  PROFILE: {
    route: "/profile",
    title: i18n.t("pages.profile"),
  },
  SETTINGS: {
    route: "/settings",
    title: i18n.t("pages.settings"),
  },
  CAREERS: {
    route: "/careers",
    title: i18n.t("pages.careers"),
  },
  OPEN_POSITIONS: {
    route: "/careers#open-positions",
    hashRoute: "open-positions",
    title: i18n.t("pages.openPositions"),
  },
  CONTACT: {
    route: "footer",
    title: i18n.t("pages.contact"),
  },
  ABOUT: {
    route: "/about-us",
    title: i18n.t("pages.about"),
  },
  CASE_STUDIES: {
    route: "/case-studies",
    title: i18n.t("pages.caseStudies"),
  },
  CASE_STUDY_INSPECT_MASTER: {
    route: "/case-studies_inspect-master",
    title: i18n.t("pages.caseStudies"),
  },
  CASE_STUDY_HAA: {
    route: "/case-studies_haa",
    title: i18n.t("pages.caseStudies"),
  },
  CASE_STUDY_FINANCIAL_ENGINE: {
    route: "/case-studies_financial-engine",
    title: i18n.t("pages.caseStudies"),
  },
  CASE_STUDY_BI_HEALTHCARE_SOLUTION: {
    route: "/case-studies_bi-healthcare-solution",
    title: i18n.t("pages.caseStudies"),
  },
  CASE_STUDY_MEDULLA: {
    route: "/case-studies_medulla",
    title: i18n.t("pages.caseStudies"),
  },
  CASE_STUDY_AI_ANOMALY_DETECTION: {
    route: "/case-studies_ai-anomaly-detection",
    title: i18n.t("pages.caseStudies"),
  },
  CASE_STUDY_SLICHKA: {
    route: "/case-studies_slichka",
    title: i18n.t("pages.caseStudies"),
  },
  PRIVACY_POLICY: {
    route: "/privacy-policy",
    title: i18n.t("pages.about"),
  },
  CAREERS_INTERN_FULL_STACK_DEVELOPER: {
    route: "/careers-intern-full-stack-developer",
    title: i18n.t("pages.careers"),
  },
  CAREERS_FULL_STACK_DEVELOPER: {
    route: "/careers-full-stack-developer",
    title: i18n.t("pages.careers"),
  },
  HOW_WE_CAN_HELP: {
    route: "/how-we-can-help",
    title: i18n.t("pages.howWeCanHelp"),
  },
};
